import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const ChurnChart = () => {
  let branch_code_from_local_storage = localStorage.getItem("currentSelectedDepartment");
  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse( localStorage.getItem("apiPaths") ) : "-"

  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    fetchChurnChartData();
  }, []);

  const fetchChurnChartData = async () => {
    try {
      const response = await axios.get(
        `${apiPaths_from_local_storage[0].API_CONFIG}/api/HRDashboard/${company_code_from_local_storage}/${branch_code_from_local_storage}/CRM_CHURN_ANALYSISGRAPH/2024-01-01/2025-03-24/-/-/-/-/-`
      );
      const apiData = response.data;

      console.log("data from api:", apiData);

      const processedData = apiData.map((item, index) => ({
        month: index, // Convert month to sequential numbers
        churn1: item.ChurnedCustomers,
      }));

      setChartData(processedData);
    } catch (error) {
      console.error("Error fetching churn data:", error);
    }
  };

  return (
<div className="w-full flex flex-col items-center px-2 ">
  {/* <h2 className="text-lg md:text-xl font-normal text-center mb-2">CHURN CHART</h2> */}

  <div className="w-full max-w-screen-lg  h-[300px] sm:h-[325px] flex justify-left items-start">
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 20, bottom: 30 }}
      >
        <XAxis
          dataKey="month"
          label={{
            value: "No. of Years",
            position: "bottom",
            offset: 10,
          }}
          tick={{ fontSize: 12 }}
        />
        <YAxis
          label={{
            value: "No. of Customers",
            angle: -90,
            position: "insideLeft",
            offset: 10,
          }}
          tick={{ fontSize: 12 }}
        />
        <CartesianGrid strokeDasharray="3 3" />
        <Tooltip />
        {/* <Legend /> */}
        <Line
          type="monotone"
          dataKey="churn1"
          stroke="#34D399"
          strokeWidth={2}
          name="Churned Customers"
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

  );
};

export default ChurnChart;